import { ApertureWindowElement } from "../Aperture";
import { DeliveryListElement } from "../../../FleetTracker/Features/Deliveries/DeliveryListElement";
import "./DeliveryInfoActivator.less";
import { DeliveriesStore } from "../../../FleetTracker/Features/Deliveries/DeliveriesStore";
import { FleetLoggerStore } from "../../../FleetTracker/Features/FleetLogger";

export class DeliveryInfoActivator { 
    public static show(routeName: string, initials = "PFN") { 
        document.body.insertAdjacentHTML("beforeend", `
            <${ApertureWindowElement.tag} title="${routeName}" width=400 height=800 center>
                <template>
                    <${DeliveryListElement.tag} no-close route-name="${routeName}" initials="${initials}"></${DeliveryListElement.tag}>
                </template>
            </${ApertureWindowElement.tag}>
        `);

        FleetLoggerStore.instance.deviceDetails = {
            deviceId: "",
            initials: initials,
            name: routeName,
            phoneNumber: ""
        };

        DeliveriesStore.instance.refresh(routeName);
    }
}